import React from 'react';
import { registerWidget } from '@okapi/core';
import { BasketLogic, BasketLogicProps } from '../../common/widgets';
import { api } from 'api';
import { BasketLogicState } from '../../../entries/server/widgets';

registerWidget(`${__NAME__}/basket-logic`, (state: BasketLogicState) => (props: JSX.IntrinsicAttributes & BasketLogicProps) => {
  api.setEnvParams(state.env, props.host);

  return <BasketLogic {...props} />
});
